var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotionTriggered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(-376 1618)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 72,
    height: 72,
    transform: "translate(376 -1618)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    transform: "translate(374.387 -1627.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M15.284,38.871c-2.7.113-9.522-.61-10.332-3.981-.662-2.753,2.465-3.511,4.469-4.182q.479-.157.157-.549C6.746,26.8,4.6,23.843,4.847,19.287,5.387,8.842,19.2,5.819,25.111,13.755,29,18.991,26.565,25.7,22.088,30.133a.357.357,0,0,0,.192.6A7.023,7.023,0,0,1,26.147,32.7c4.391,4.487-6.891,6.185-8.851,6.194q-.479,0-.383.479l.488,2.431a.611.611,0,0,1-.375.74l-.47.227a.523.523,0,0,1-.7-.253,4.232,4.232,0,0,1-.218-3.18Q15.8,38.854,15.284,38.871Zm9.74-20.83C21.617,2.6-7.445,14.827,15.388,33a.636.636,0,0,0,.74.044C20.807,30.142,26.339,23.983,25.023,18.041Zm-9.8,16.979L11.6,32.241a.909.909,0,0,0-.88-.148l-3.4,1.133a1.237,1.237,0,0,0-.07,2.317,22.217,22.217,0,0,0,17.362-.026,1.22,1.22,0,0,0-.044-2.274L21.1,31.98a.784.784,0,0,0-.784.131l-3.711,2.9A1.124,1.124,0,0,1,15.223,35.02Z",
    transform: "translate(0 0)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M15.667,33.257C-7.167,15.085,21.9,2.853,25.3,18.3c1.315,5.941-4.216,12.1-8.895,15a.636.636,0,0,1-.74-.044Zm4.216-12.675a3.676,3.676,0,1,0-3.676,3.676,3.676,3.676,0,0,0,3.676-3.676Z",
    transform: "translate(-0.278 -0.258)",
    fill: "#f2e153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M20.7,21.416a3.676,3.676,0,1,1-3.676-3.676A3.676,3.676,0,0,1,20.7,21.416Zm-1.873.052a1.821,1.821,0,1,0-1.821,1.821A1.821,1.821,0,0,0,18.83,21.469Z",
    transform: "translate(-1.098 -1.092)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1.821,
    cy: 1.821,
    r: 1.821,
    transform: "translate(14.09 18.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M15.467,38.373a1.124,1.124,0,0,0,1.385-.009l3.711-2.9a.784.784,0,0,1,.784-.131L24.815,36.6a1.22,1.22,0,0,1,.044,2.274A22.217,22.217,0,0,1,7.5,38.9a1.237,1.237,0,0,1,.07-2.317l3.4-1.133a.909.909,0,0,1,.88.148Z",
    transform: "translate(-0.244 -3.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M53.7,67.877q.688-.052.183-.523a31.086,31.086,0,0,1-6.194-7.867.74.74,0,0,0-.566-.383l-1.673-.2q-.836-.1-.218-.671l.967-.889a.729.729,0,0,0,.227-.775C43.5,45.793,51.338,35.792,62.646,37.482a14.567,14.567,0,0,1,11.412,20.56,27.028,27.028,0,0,1-6.821,9.086q-.409.366.113.549c3.023,1.011,5.785,1.22,7.814,3.877a1.986,1.986,0,0,1,.017,2.378c-2.7,3.694-10.463,4.469-14.662,4.46a2.644,2.644,0,0,0-1.42.505.887.887,0,0,1-.784.035c-2.648-1.089-14.165-2.265-12.527-6.926C46.721,69.376,51.26,68.06,53.7,67.877Zm19.558-12.6C77.978,37.543,49.9,32.194,47.5,50.384,46.486,58.129,54,66.013,60.346,70.438a.456.456,0,0,0,.6-.017C66.174,66.266,71.688,61.2,73.257,55.28Zm-.078,16.587a12.267,12.267,0,0,0-7.605-2.413,1.63,1.63,0,0,0-.984.34l-3.8,2.927a.569.569,0,0,1-.775-.017l-3.694-3.023a1.05,1.05,0,0,0-.688-.244,13.426,13.426,0,0,0-8,2.553.649.649,0,0,0-.209.81c2.352,5.14,22.415,4.356,25.9.671A.937.937,0,0,0,73.178,71.867Z",
    transform: "translate(-5.171 -3.612)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M47.866,50.65c2.4-18.19,30.473-12.841,25.752,4.9-1.568,5.915-7.083,10.985-12.31,15.141a.456.456,0,0,1-.6.017C54.365,66.278,46.847,58.394,47.866,50.65ZM66.4,50.51a5.514,5.514,0,1,0-5.514,5.514A5.514,5.514,0,0,0,66.4,50.51Z",
    transform: "translate(-5.533 -3.877)",
    fill: "#f2e153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M67.529,51.344a5.514,5.514,0,1,1-5.514-5.514A5.514,5.514,0,0,1,67.529,51.344ZM65.7,51.318a3.737,3.737,0,1,0-3.737,3.737A3.737,3.737,0,0,0,65.7,51.318Z",
    transform: "translate(-6.657 -4.711)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 3.737,
    cy: 3.737,
    r: 3.737,
    transform: "translate(51.568 42.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 1.786,
    cy: 0.923,
    rx: 1.786,
    ry: 0.923,
    transform: "translate(17.881 44.369) rotate(69.9)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 1.768,
    cy: 0.871,
    rx: 1.768,
    ry: 0.871,
    transform: "translate(19.821 49.574) rotate(48.6)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 1.716,
    cy: 0.958,
    rx: 1.716,
    ry: 0.958,
    transform: "translate(23.6 53.137) rotate(13.3)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 1.716,
    cy: 0.958,
    rx: 1.716,
    ry: 0.958,
    transform: "translate(28.926 53.877) rotate(-1.6)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 2.021,
    cy: 0.845,
    rx: 2.021,
    ry: 0.845,
    transform: "matrix(1, -0.012, 0.012, 1, 34.239, 53.862)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M73.532,76.621a.937.937,0,0,1,.148,1.6c-3.485,3.685-23.548,4.469-25.9-.671a.649.649,0,0,1,.209-.81,13.426,13.426,0,0,1,8-2.553,1.05,1.05,0,0,1,.688.244l3.694,3.023a.569.569,0,0,0,.775.017l3.8-2.927a1.63,1.63,0,0,1,.984-.34A12.267,12.267,0,0,1,73.532,76.621Z",
    transform: "translate(-5.525 -8.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 1.856,
    cy: 0.906,
    rx: 1.856,
    ry: 0.906,
    transform: "translate(47.826 78.165) rotate(-34.4)",
    fill: "#191a1b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 1.795,
    cy: 0.932,
    rx: 1.795,
    ry: 0.932,
    transform: "translate(42.57 79.437) rotate(-12.1)",
    fill: "#191a1b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionTriggered);
export default __webpack_public_path__ + "static/media/motion-triggered.d634e293eeae20353b696d4d18277b42.svg";
export { ForwardRef as ReactComponent };